export default __webpack_public_path__ + "static/media/simport.8c7b0679.PNG";